import { SxProps, Theme } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const myWishListHeaderSX = (theme: Theme, isSelected: boolean): SxProps => ({
	display: 'flex',
	cursor: 'pointer',
	borderRadius: '3px',
	minWidth: '50px',
	justifyContent: 'center',
	padding: '10px',
	height: '44px',
	gap: '2px',
	...(isSelected && { backgroundColor: 'grey.50' }),
	'& svg': {
		color: isSelected ? 'primary.main' : 'grey.500',
	},
	'&:hover': {
		backgroundColor: 'grey.50',
		'& svg': {
			color: 'primary.main',
		},
	},
	[theme.breakpoints.down('md')]: {
		padding: '10px 5px',
	},
});

export const headerMyWishListMobileContainerSX = (theme: Theme): SxProps => ({
	display: 'flex',
	' > p': {
		paddingTop: '1px',
		paddingLeft: '3px',
		[theme.breakpoints.down('md')]: {
			paddingLeft: 0,
		},
	},
	' > span': {
		opacity: 1,
	},
	[theme.breakpoints.up('lg')]: {
		flexDirection: 'column',
		gap: '2px',
		alignItems: 'center',
		padding: '0 5px',
		height: '44px',
		justifyContent: 'center',
	},
	[theme.breakpoints.down('lg')]: {
		flexDirection: 'column',
		gap: '2px',
		alignItems: 'center',
		padding: '10px',
	},
	[theme.breakpoints.down('md')]: {
		padding: '10px 0',
	},
});

export const myWishlistHeaderIconSX = (isSelected: boolean): SxProps => ({
	marginLeft: '2px',
	height: '24px',
	...(isSelected && {
		fontVariationSettings: '"FILL" 1',
		color: 'primary.main',
	}),
});

export const myWishListHeaderIconLabelSX: SxProps = {
	color: 'grey.500',
	textAlign: 'center',
};

export const myWishListBadgeSX: SxProps = {
	'.MuiBadge-badge': {
		right: 6,
		top: 5,
		borderRadius: '3px',
		minWidth: 'min-content',
		fontSize: '8px',
		color: 'primary.main',
		backgroundColor: 'background.paper',
		padding: '0 2px',
		height: '10px',
	},
};

export const myWishListHeaderIconSX = (color: string): SxProps => ({
	color,
});

export const myWishListHeaderLabelSX = (): SxProps => ({
	color: 'grey.500',
});

interface PanelStyles {
	disabledButton: SxProps<Theme>;
	discountBadge: SxProps<Theme>;
	savingsText: SxProps<Theme>;
	divider: SxProps<Theme>;
	linkColor: SxProps<Theme>;
	emptyImage: SxProps<Theme>;
	itemContainer: SxProps<Theme>;
	itemText: SxProps<Theme>;
	itemLink: SxProps<Theme>;
	mobileIcon: SxProps<Theme>;
}

export const panelStyles: PanelStyles = {
	disabledButton: {
		'&.Mui-disabled': {
			backgroundColor: 'grey.50',
			color: 'grey.200',
			border: '3px solid',
			borderColor: 'grey.50',
		},
	},
	discountBadge: {
		backgroundColor: 'grey.50',
		color: 'text.highlight',
		fontWeight: OpenSansFontWeights.semibold,
		padding: '2px 5px',
		fontSize: '12px',
		borderRadius: '3px',
	},
	savingsText: {
		textDecoration: 'line-through',
	},
	divider: {
		width: '100%',
		my: '10px',
		borderColor: 'grey.50',
	},
	linkColor: {
		color: 'secondary.main',
	},
	emptyImage: {
		width: '90px',
		height: '90px',
	},
	itemContainer: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		padding: '10px 20px',
		'&:hover': {
			backgroundColor: 'grey.50',
		},
	},
	itemText: {
		color: 'secondary.main',
		fontWeight: OpenSansFontWeights.regular,
		marginLeft: '5px',
	},
	itemLink: {
		padding: 0,
		width: '100%',
	},
	mobileIcon: {
		mr: '5px',
		width: '24px',
		height: '24px',
	},
};
